export const CLEAR_STATE = 'COMPLAINT_SELLER.COMPLAINT_ASSIGN.CLEAR_STATE';

export const COMPLAINT_ASSIGN = {
    REQUEST: 'COMPLAINT_SELLER.COMPLAINT_ASSIGN.REQUEST',
    SUCCESS: 'COMPLAINT_SELLER.COMPLAINT_ASSIGN.SUCCESS',
    FAILED: 'COMPLAINT_SELLER.COMPLAINT_ASSIGN.FAILED',
};
